<template>
  <div class="container-fluid basic-background">
    <div class="row">
      <!-- 左側：圖片上傳區 -->
      <div class="col-lg-5 mb-4 order-2 order-lg-1">
        <div class="block-card py-4 h-100 d-flex flex-column">
          <h1 class="h4 text-left letter-2px mx-4 mb-4">
            {{ $t("originPortrait") }}
          </h1>

          <!-- 拍照 / 預覽區 -->
          <div class="upload-box mx-4">
            <!-- 相機畫面 -->
            <div v-if="cameraStage === 'live' || cameraStage === 'countdown'" class="camera-preview">
              <video
                ref="videoEl"
                autoplay
                playsinline
                muted
                class="fixed-preview"
              ></video>

              <div
                v-if="cameraLoading"
                class="camera-overlay"
              >
                <div class="spinner-border" aria-hidden="true"></div>
                <output class="mt-2 text-white">
                  {{ $t("cameraLoading") }}
                </output>
              </div>

              <div
                v-if="cameraStage === 'countdown'"
                class="camera-countdown-overlay"
              >
                <div class="camera-countdown-number">
                  {{ countdown }}
                </div>
              </div>
            </div>

            <!-- 已拍攝 / 已上傳圖片 -->
            <div v-else-if="uploadedImage" class="image-preview">
              <img :src="uploadedImage" class="fixed-preview" alt="Uploaded preview">
            </div>

            <!-- 初始狀態 -->
            <div v-else class="upload-placeholder">
              <button class="btn block-btn block-btn-hover" @click="startInlineCamera">
                <i class="bi bi-camera upload-icon"></i>
                {{ $t("clickToTakePhoto") }}
              </button>
            </div>
          </div>

          <!-- 生成選項 -->
          <div class="mt-4 px-4">
            <div class="form-label mb-2">
              {{ $t("genderSelection") }}
            </div>

            <fieldset class="btn-group w-100">
              <legend class="visually-hidden">{{ $t("genderSelection") }}</legend>

              <input
                type="radio"
                class="btn-check"
                name="genderOptions"
                id="genderMale"
                autocomplete="off"
                value="male"
                v-model="selectedGender"
              >
              <label
                :class="['btn', selectedGender === 'male' ? 'btn-secondary' : 'btn-outline-secondary']"
                for="genderMale"
              >
                {{ $t("male") }}
              </label>

              <input
                type="radio"
                class="btn-check"
                name="genderOptions"
                id="genderFemale"
                autocomplete="off"
                value="female"
                v-model="selectedGender"
              >
              <label
                :class="['btn', selectedGender === 'female' ? 'btn-secondary' : 'btn-outline-secondary']"
                for="genderFemale"
              >
                {{ $t("female") }}
              </label>
            </fieldset>

            <!-- 操作按鈕列 -->
            <div class="action-row mt-4">
              <button
                v-if="uploadedImage"
                class="btn block-btn-white"
                @click="retakePhoto"
              >
                {{ $t("reshoot") }}
              </button>

              <button
                v-if="uploadedImage || timePortrait"
                class="btn block-btn-white"
                @click="clearAll"
              >
                {{ $t("clearData") }}
              </button>

              <button
                class="btn block-btn block-btn-hover action-generate-btn"
                :disabled="!uploadedImage || isLoading"
                @click="generatePortrait"
              >
                {{ uploadedImage ? (isLoading ? $t("generating") : $t("generateMyTimePortrait")) : $t("pleaseTakePhoto") }}
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- 右側：生成的圖片顯示 -->
      <div class="col-lg-7 mb-4 order-1 order-lg-2">
        <div class="block-card px-4 py-4 h-100 d-flex flex-column">
          <h4 class="text-left letter-2px mb-4">
            {{ $t("timePortrait") }}
          </h4>

          <div class="result-display-container">
            <div v-if="isLoading" class="loading-container">
              <div class="loading-spinner">
                <div class="gradient-circle"></div>
                <div class="loading-text">
                  {{ $t("generatingYouriImage") }}
                </div>
                <div class="loading-tips">
                  {{ $t("timePortraitTips") }}
                </div>
              </div>
            </div>

            <div v-else-if="timePortrait" class="result-content-wrap">
              <div class="result-image-container">
                <img :src="timePortrait" class="result-image" alt="Time portrait result">
              </div>
              
              <div class="qr-panel" v-if="qrDataUrl">
                <div class="qr-panel-inner">
                  <div class="qr-text">{{ $t("scanToDownload") }}</div>
                  <img :src="qrDataUrl" alt="QRCode" class="qr-image">
                  

                  <!-- <div class="form-check consent-check mt-3">
                    <input
                      id="displayConsentCheckbox"
                      v-model="agreeDisplayConsent"
                      class="form-check-input"
                      type="checkbox"
                    >
                    <label class="form-check-label consent-label" for="displayConsentCheckbox">
                      {{ $t("displayConsentLabel") }}
                    </label>
                  </div>

                  <div class="consent-help-text mt-2">
                    {{ $t("displayConsentDescription") }}
                  </div>

                  <button
                    class="btn block-btn block-btn-hover print-btn mt-3"
                    type="button"
                    :disabled="!agreeDisplayConsent || isSubmittingConsent || !timePortraitId"
                    @click="handlePrintWithConsent"
                  >
                    <i class="bi bi-printer me-2"></i>
                    {{
                      !agreeDisplayConsent
                        ? $t("agreeBeforePrint")
                        : (isSubmittingConsent ? $t("processing") : $t("printImage"))
                    }}
                  </button> -->
                </div>
              </div>
            </div>

            <div v-else class="no-result-placeholder">
              <p class="no-image-text">
                {{ $t("noImageGenerated") }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- 錯誤訊息 -->
      <div v-if="errorMessage" class="col-12">
        <div class="alert alert-danger">
          {{ errorMessage }}
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api/axios';
import config from '@/config.json'
import QRCode from 'qrcode'

export default {
  name: 'TimePortrait',
  data() {
    return {
      uploadedImage: null,        // 上傳圖片的 URL
      imageFile: null,            // 上傳的檔案
      timePortrait: "",           // 生成的圖片 URL
      timePortraitId:"",          // 生成的圖片 ID（用於標記是否可展示於會場）
      agreeDisplayConsent: false, // 使用者同意(checkbox) 狀態
      isSubmittingConsent: false, // 是否正在呼叫API(提交同意)狀態
      selectedGender: "male",     // 生成肖像性別
      isLoading: false,           // 按鈕 Loading 狀態
      errorMessage: "",           // 錯誤訊息
      isDragging: false,          // 是否正在拖曳

      qrDataUrl: '',
      qrTargetUrl: '',

      // 相機
      cameraOn: false,
      stream: null,
      cameraError: "",
      cameraStage: "idle", // idle | live | countdown
      cameraLoading: false,
      countdownSeconds: 5,
      countdown: 5,
      countdownTimer: null,
    };
  },
  methods: {
    /** 處理圖片上傳 */
    handleFileUpload(event) {
      const file = event.target.files[0];
      this.loadImage(file);
    },

    /** 處理拖曳上傳 */
    onDragOver() {
      this.isDragging = true;
    },
    onDragLeave() {
      this.isDragging = false;
    },
    onDrop(event) {
      this.isDragging = false;
      const file = event.dataTransfer.files[0];
      this.loadImage(file);
    },

    /** 加載圖片 */
    loadImage(file) {
      if (file && file.type.startsWith("image/")) {
        this.imageFile = file;
        this.uploadedImage = URL.createObjectURL(file);
        this.errorMessage = "";
        this.timePortrait = ""; // 清除之前的結果
        this.timePortraitId = "";
        this.agreeDisplayConsent = false;
      } else {
        this.errorMessage = "請上傳有效的圖片檔案";
      }
    },

    /** 清除已上傳圖片 */
    clearImage() {
      if (this.uploadedImage && this.uploadedImage.startsWith('blob:')) {
        URL.revokeObjectURL(this.uploadedImage);
      }

      this.uploadedImage = null;
      this.imageFile = null;
      this.timePortrait = "";
      this.timePortraitId = "";
      this.agreeDisplayConsent = false
      this.errorMessage = "";
    },

    /** 發送請求執行生成時代肖像 */
    async generatePortrait() {
      if (!this.imageFile) {
        this.errorMessage = "請上傳圖片";
        return;
      }

      this.isLoading = true;
      this.errorMessage = "";
      this.timePortrait = "";
      this.timePortraitId = "";
      this.agreeDisplayConsent = false
      this.qrDataUrl = "";
      this.qrTargetUrl = "";

      const formData = new FormData();
      formData.append("image", this.imageFile);
      formData.append("gender", this.selectedGender);

      try {
        const response = await api.post(
          `${config.apiBaseUrl}/stable_diffusion/api/time-portrait`,
          formData
        );

        const imageUrl = response.data && response.data.image_url;
        if (!imageUrl) {
          throw new Error("Missing image_url in response");
        }

        this.timePortrait = this.resolveImageUrl(imageUrl);
        this.timePortraitId = response.data.id || "";

        // 生成完成後直接做 QRCode
        await this.buildQrCode();

      } catch (error) {
        console.error("肖像生成失敗:", error);
        this.errorMessage = "肖像生成失敗，請稍後再試";
      } finally {
        this.isLoading = false;
      }
    },

    async buildQrCode() {
      if (!this.timePortrait) return;

      if (this.timePortrait.startsWith('blob:') || this.timePortrait.startsWith('data:')) {
        return;
      }

      this.qrTargetUrl = `${config.publicWebBaseUrl}/download?img=${encodeURIComponent(this.timePortrait)}`;

      try {
        this.qrDataUrl = await QRCode.toDataURL(this.qrTargetUrl, {
          width: 220,
          margin: 1,
          errorCorrectionLevel: 'M',
        });
      } catch (e) {
        console.error('QRCode 產生失敗', e);
      }
    },

    /** 下載圖片 */
    downloadImage() {
      if (this.timePortrait) {
        const link = document.createElement('a');
        link.href = this.timePortrait;
        link.download = `Portrait of Time_${Date.now()}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    },

    /** 開啟拍照 Modal */
    async startInlineCamera() {
      this.resetCameraFlow();
      this.cameraLoading = true;
      this.cameraStage = "live";

      await this.startCamera();
      await this.ensureVideoAttached();
      this.cameraLoading = false;
      this.startCountdownAndCapture();
    },

    async startCamera() {
      this.cameraError = "";
      try {
        this.cleanupCamera(); // 避免重複占用

        const constraints = {
          video: { width: { ideal: 1280 }, height: { ideal: 720 } },
          audio: false,
        };

        this.stream = await navigator.mediaDevices.getUserMedia(constraints);

        await this.$nextTick();
        const video = this.$refs.videoEl;
        video.srcObject = this.stream;

        this.cameraOn = true;
        await video.play();
      } catch (e) {
        this.cameraError =
          "無法開啟相機：請確認已允許相機權限，且使用 HTTPS（或 localhost）。";
        this.cameraOn = false;
        this.stream = null;
      }
    },

    async waitForVideoReady() {
      const video = this.$refs.videoEl;
      if (!video) return;

      if (video.readyState >= 2 && video.videoWidth > 0) return;

      await new Promise((resolve) => {
        const onReady = () => resolve();
        video.addEventListener("loadedmetadata", onReady, { once: true });
        video.addEventListener("canplay", onReady, { once: true });
      });
    },

    startCountdownAndCapture() {
      if (!this.cameraOn || this.cameraStage === "countdown") return;

      this.cameraStage = "countdown";
      this.countdown = this.countdownSeconds;

      this.countdownTimer = setInterval(async () => {
        this.countdown -= 1;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.countdownTimer = null;
          await this.takePhotoToPreview();
        }
      }, 1000);
    },

    async takePhotoToPreview() {
      try {
        const video = this.$refs.videoEl;
        if (!video) return;

        await this.waitForVideoReady();

        const canvas = document.createElement("canvas");
        const w = video.videoWidth || 1280;
        const h = video.videoHeight || 720;
        canvas.width = w;
        canvas.height = h;

        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, w, h);

        const blob = await new Promise((resolve) =>
          canvas.toBlob(resolve, "image/jpeg", 0.92)
        );
        if (!blob) throw new Error("toBlob failed");

        const filename = `webcam_${new Date().toISOString().replace(/[:.]/g, "-")}.jpg`;
        const file = new File([blob], filename, { type: "image/jpeg" });

        // 直接採用，不再多一步確認
        this.loadImage(file);

        this.cleanupCamera();
        this.cameraStage = "idle";
      } catch (e) {
        console.error(e);
        this.cameraError = "拍照失敗：請重拍一次。";
        this.cameraStage = "idle";
      }
    },

    /** 重拍：回到 live，重新把 stream 掛回 video + play，再倒數 */
    async retakePhoto() {
      this.clearImage();
      await this.startInlineCamera();
    },

    clearAll() {
      this.clearImage();
      this.qrDataUrl = '';
      this.qrTargetUrl = '';
      this.selectedGender = 'male';
      this.errorMessage = '';
      this.cleanupCamera();
      this.cameraStage = 'idle';
    },

    cleanupCamera() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
      if (this.stream) {
        this.stream.getTracks().forEach((t) => t.stop());
      }
      const video = this.$refs.videoEl;
      if (video) video.srcObject = null;

      this.stream = null;
      this.cameraOn = false;
    },

    resetCameraFlow() {
      this.cameraStage = "live";
      this.countdown = this.countdownSeconds;

      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }

      this.capturedFile = null;
      if (this.capturedPreview) {
        URL.revokeObjectURL(this.capturedPreview);
        this.capturedPreview = "";
      }
      this.cameraError = "";
    },

    async ensureVideoAttached() {
      this.cameraLoading = true;

      await this.$nextTick();
      const video = this.$refs.videoEl;
      if (!video) return;

      // video 可能因 v-if 重新生成，所以每次都保險掛回 stream
      if (this.stream && video.srcObject !== this.stream) {
        video.srcObject = this.stream;
      }

      await video.play(); //避免灰畫面 / 全黑截圖
      await this.waitForVideoReady();

      this.cameraLoading = false;
    },

    resolveImageUrl(url) {
      // 如果是相對路徑（/media/...）
      if (url.startsWith('/media/')) {
        // 正式環境（同網域）
        if (window.location.origin.includes(config.apiBaseUrl)) {
          return url
        }
        // 開發環境：補上 API host
        return `${config.apiBaseUrl}${url}`
      }

      return url
    },
    printGeneratedImage() {
      if (!this.timePortrait) return

      const printWindow = window.open('', '_blank', 'width=900,height=1200')
      if (!printWindow) {
        alert(this.$t('printPopupBlocked'))
        return
      }

      const imageUrl = this.timePortrait

      printWindow.document.write(`
        <!DOCTYPE html>
        <html lang="${this.$i18n.locale}">
        <head>
          <meta charset="utf-8">
          <meta name="viewport" content="width=device-width, initial-scale=1">
          <title>Print</title>
          <style>
            html, body {
              margin: 0;
              padding: 0;
              background: #fff;
              width: 100%;
              height: 100%;
            }

            body {
              overflow: hidden;
            }

            .print-page {
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              box-sizing: border-box;
              background: #fff;
            }

            .print-image {
              display: block;
              max-width: 100%;
              max-height: 100%;
              width: auto;
              height: auto;
              object-fit: contain;
            }

            // @page {
            //   size: 4in 6in;
            //   margin: 0;
            // }

            @media print {
              .print-page {
                width: 100%;
                height: 100%;
              }

              .print-stage {
                width: 100%;
                height: 100%;
                padding: 0;
              }

              .print-image {
                max-width: 100%;
                max-height: 100%;
                object-fit: contain;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-page">
            <img id="printImage" class="print-image" src="${imageUrl}" alt="Generated portrait">
          </div>

          <script>
            const img = document.getElementById('printImage')

            function doPrint() {
              setTimeout(() => {
                window.focus()
                window.print()
              }, 300)
            }

            if (img.complete) {
              doPrint()
            } else {
              img.onload = doPrint
              img.onerror = function () {
                document.body.innerHTML = '<p style="padding:24px;font-family:Arial,sans-serif;">Image failed to load.</p>'
              }
            }

            window.onafterprint = function () {
              window.close()
            }
          ${'</scr' + 'ipt>'}
        </body>
        </html>
      `)

      printWindow.document.close()
    },

    async handlePrintWithConsent() {
      if (!this.agreeDisplayConsent || !this.timePortraitId) {
        return
      }

      try {
        this.isSubmittingConsent = true

        await api.post(
          `${config.apiBaseUrl}/stable_diffusion/api/time-portrait/display-consent`,
          {
            id: this.timePortraitId,
            display_consent: true,
          }
        )

        // this.printGeneratedImage()
        this.$router.push({
          name: 'TimePortraitPrint',
          query: {
            img: this.timePortrait,
          },
        })
      } catch (error) {
        console.error( error)
        alert(this.$t('displayConsentUpdateFailed'))
      } finally {
        this.isSubmittingConsent = false
      }
    },
  },

  beforeUnmount() {
    this.cleanupCamera();

    if (this.uploadedImage && this.uploadedImage.startsWith('blob:')) {
      URL.revokeObjectURL(this.uploadedImage);
  }
  },
};
</script>

<style scoped>
/* ===== 左側：原始肖像 / 拍攝區 ===== */
.upload-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50vh;
  padding: 20px;
  text-align: center;
  background-color: #f8f9fa;
  border-radius: 15px;
  transition: all 0.3s ease;
}

.upload-box:hover {
  border-color: #bbb;
  background-color: #f0f0f0;
}

.upload-box.drag-over {
  border-color: #007bff;
  background-color: #e3f2fd;
}

.upload-placeholder p {
  margin: 10px 0;
  color: #6c757d;
  font-size: 1rem;
}

.upload-icon {
  color: #fff;
  font-size: 16px;
}

.debug-upload-btn {
  border: 1px dashed #999;
  color: #666;
  background: transparent;
}

/* 相機畫面 / 已拍攝預覽共用 */
.camera-preview,
.image-preview {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.fixed-preview {
  display: block;
  width: 100%;
  max-width: 100%;
  max-height: 460px;
  object-fit: contain;
  border-radius: 10px;
  background: #111;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

/* 相機載入遮罩 */
.camera-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.4);
}

/* 倒數覆蓋層 */
.camera-countdown-overlay {
  position: absolute;
  inset: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

.camera-countdown-number {
  font-size: 140px;
  font-weight: 800;
  line-height: 1;
  color: rgba(255, 255, 255, 0.82);
  text-shadow: 0 8px 30px rgba(0, 0, 0, 0.55);
  user-select: none;
  animation: countdownPulse 0.9s ease;
}

@keyframes countdownPulse {
  0% {
    transform: scale(1.35);
    opacity: 0;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
  80% {
    transform: scale(0.92);
  }
  100% {
    transform: scale(1);
  }
}

.close-btn:hover {
  background: #333;
}

/* ===== 左側：操作按鈕 ===== */
.action-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.action-generate-btn {
  min-width: 220px;
}

.upscale-btn:disabled {
  background-color: #6c757d !important;
  border-color: #6c757d !important;
  cursor: not-allowed;
  opacity: 0.6;
}

.upscale-btn:not(:disabled):hover {
  background-color: #333 !important;
  border-color: #333 !important;
  transform: translateY(-1px);
}

/* ===== 右側：生成結果 + QRCode ===== */
.result-content-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  flex-wrap: nowrap;
  min-height: 520px;
}

.result-image-container {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  text-align: center;
}

.result-image {
  max-width: 100%;
  max-height: 520px;
  object-fit: contain;
  border-radius: 12px;
}

.qr-panel {
  flex: 0 0 240px;
  display: flex;
  align-items: center;   /* 垂直置中 */
  justify-content: center;
}

.qr-panel-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.qr-image {
  width: 220px;
  height: 220px;
  padding: 8px;
  background: #fff;
  border-radius: 12px;
}

.qr-text {
  margin-top: 14px;
  font-weight: 600;
  text-align: center;
}

.qr-subtext {
  margin-top: 6px;
  font-size: 14px;
  line-height: 1.5;
  color: #6c757d;
  text-align: center;
}

.no-result-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 520px;
}

.print-btn {
  min-width: 140px;
}

.print-btn:disabled {
  background-color: #adb5bd !important;
  border-color: #adb5bd !important;
  color: #fff !important;
  cursor: not-allowed;
  opacity: 0.75;
}

.consent-check {
  width: 100%;
  max-width: 240px;
  text-align: left;
}

.consent-label {
  font-size: 14px;
  line-height: 1.5;
  color: #343a40;
}

.consent-help-text {
  max-width: 240px;
  font-size: 12px;
  line-height: 1.5;
  color: #6c757d;
  text-align: left;
}

/* ===== 響應式 ===== */
@media (max-width: 991.98px) {
  .upload-box {
    min-height: 320px;
  }

  .action-row {
    flex-direction: column;
    align-items: stretch;
  }

  .action-row .btn {
    width: 100%;
  }

  .action-generate-btn {
    min-width: 0;
  }

  .result-content-wrap {
    flex-direction: column;
    align-items: center;
    min-height: auto;
  }

  .qr-panel {
    flex: none;
    width: 100%;
    margin-top: 12px;
  }
}

@media (max-width: 768px) {
  .upload-box {
    min-height: 200px;
    padding: 15px;
  }

  .camera-countdown-number {
    font-size: 100px;
  }
}

@media (min-width: 992px) and (max-width: 1366px) {
  .result-content-wrap {
    flex-direction: column;
    align-items: center;
    gap: 16px;
    min-height: auto;
  }

  .result-image-container {
    width: 100%;
  }

  .result-image {
    display: block;
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 62vh;
    object-fit: contain;
  }

  .qr-panel {
    flex: none;
    width: 100%;
    margin-top: 8px;
  }

  .qr-image {
    width: 150px;
    height: 150px;
  }
}
</style>